'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'user-shakespeare';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e2c2';
var svgPathData = ['M16 512c8.8 0 16-7.2 16-16 0-49.9 25.4-93.9 64-119.8l0 7.8c0 26.5 21.5 48 48 48l64 0 0 64c0 8.8 7.2 16 16 16L16 512zM80 204c0-4.3 1.4-8.5 4-12l15.1-20.1c4.3 19.4 13 37.1 25 52.1L100 224c-11 0-20-9-20-20zM224 512c8.8 0 16-7.2 16-16l0-64 64 0c26.5 0 48-21.5 48-48l0-7.8c38.6 25.8 64 69.8 64 119.8 0 8.8 7.2 16 16 16l-208 0zm99.9-288c12-15 20.7-32.7 25-52.1L364 192c2.6 3.5 4 7.7 4 12 0 11-9 20-20 20l-24.1 0z', 'M320 144c0 47.6-34.6 87.1-80 94.7l0-14.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 14.7c-45.4-7.6-80-47.1-80-94.7l0-16c0-53 43-96 96-96s96 43 96 96l0 16zM224 272c22.5 0 43.6-5.8 62-16l62 0c28.7 0 52-23.3 52-52 0-11.3-3.6-22.2-10.4-31.2l-37.7-50.3C349 54.4 292.9 0 224 0S99 54.4 96.1 122.5L58.4 172.8c-6.8 9-10.4 19.9-10.4 31.2 0 28.7 23.3 52 52 52l62 0c18.4 10.2 39.5 16 62 16zM99.1 171.9c4.3 19.4 13 37.1 25 52.1L100 224c-11 0-20-9-20-20 0-4.3 1.4-8.5 4-12l15.1-20.1zM348 224l-24.1 0c12-15 20.7-32.7 25-52.1L364 192c2.6 3.5 4 7.7 4 12 0 11-9 20-20 20zM231.2 145.7c-4.5-2.3-9.8-2.3-14.3 0l-32 16c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l24.8-12.4 24.8 12.4c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-32-16zM32 496c0-49.9 25.4-93.9 64-119.8l0 7.8c0 26.5 21.5 48 48 48l64 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 64 0c26.5 0 48-21.5 48-48l0-7.8c38.6 25.8 64 69.8 64 119.8 0 8.8 7.2 16 16 16s16-7.2 16-16c0-69.2-39.9-129.1-98-157.8-5.9-19.8-24.3-34.2-46-34.2l-160 0c-21.7 0-40 14.4-46 34.2-58.1 28.8-98 88.6-98 157.8 0 8.8 7.2 16 16 16s16-7.2 16-16zm96-144c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserShakespeare = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;